import { isDevHost } from "../../credentials/consts/links";
export function stripTrailingSlash(str) {
    return str.endsWith("/") ? str.slice(0, -1) : str;
}
export const updateQuery = (router, params) => {
    const location = router.location;
    const currentParams = new URLSearchParams(location.search);
    const currentParamsObject = Object.fromEntries(currentParams);
    Object.keys(params).forEach((key) => {
        currentParamsObject[key] = String(params[key]);
    });
    const newParams = new URLSearchParams(currentParamsObject);
    router.navigate({
        ...location,
        pathname: stripTrailingSlash(location.pathname),
        search: newParams.toString(),
    }, { replace: true });
};
export const setAccountId = (router, accountId) => {
    const location = router.location;
    const url = new URL(location.pathname + location.search, window.location.origin);
    url.searchParams.set("accountId", accountId.toString());
    url.protocol = "https";
    router.navigate({
        ...location,
        pathname: stripTrailingSlash(location.pathname),
        search: url.search,
    }, { replace: true });
};
// TODO Use isDev instead in Audience
export const isCiHost = isDevHost;
